export interface CustomerLedgerResponse {
  partyAccountBook: PartyAccountBook[];
  totalPartyAccountBook: number;
  startRecord: number;
  endRecord: number;
  statusCode: number;
  responseStatus: string;
  divisionData: DivisionData[];
  creditLimit: number;
  erpTransactionTypes?: Array<{
    type: keyof typeof TransactionTypes;
    name: TransactionTypes[keyof TransactionTypes];
  }>;
}

export interface PartyAccountBook {
  id: string;
  transactionDate: string;
  createdDate: string;
  updatedDate: string;
  sellerWorkspaceId: string;
  buyerWorkspaceId: string;
  inviteId: string;
  docNumber: string;
  narration: string;
  creditAmount: number;
  debitAmount: number;
  balance: number;
  transactionType: string;
  paymentId?: string;
  divisionName?: string;
  chequeNumber?: string;
  clearingDate?: string;
  isProvisional?: boolean;
  type?: string;
  month?: string;
  transactionTypeName?: string;
  erpTransactionType?: string;
}

interface DivisionData {
  divisionId: string;
  divisionName: string;
}

export interface CustomerLedgerRequest {
  sellerWorkspaceId: string;
  inviteId: string;
  startDate: string;
  endDate: string;
  pageNo?: number;
  pageSize?: number;
  searchKey?: string;
  sortBy?: string;
  filter?: any;
  sortDirection?: string;
  divisionId?: string;
}

export interface GetLedgerTrailBalanceSummaryRequest {
  inviteId: string;
  startDate: string;
  endDate: string;
  sellerWorkspaceId: string;
}

export interface GetLedgerTrailBalanceSummaryResponse {
  closingBalance: number | string;
  netBalance: number;
  openingBalance: number;
}

export interface DownloadLedgerRequest {
  sellerWorkspaceId: string;
  inviteId: string;
  startDate: string;
  endDate: string;
  searchKey?: string;
  filter?: string;
  pageNo?: number;
  pageSize?: number;
  downloadContentType?: string;
}

export enum TransactionTypes {
  INV = 'Invoice',
  PYMNT = 'Payment',
  DN = 'Debit Note',
  CN = 'Credit Note',
  OB = 'Opening Balance',
  SPMNT = 'Seller Payment',
  PINV = 'Purchase Invoice',
  JCR = 'Journal Credit',
  JDR = 'Journal Debit',
}
